import { Instagram, Youtube, Music2, Facebook } from "lucide-react";
import { CONTACT, LOGO, FOOTER_LINE } from "@/lib/constants";
import { useConsent } from "@/context/ConsentContext";

const socials = [
  { icon: Instagram, href: CONTACT.instagram, key: "instagram", label: "Instagram" },
  { icon: Music2, href: CONTACT.tiktok, key: "tiktok", label: "TikTok" },
  { icon: Facebook, href: CONTACT.facebook, key: "facebook", label: "Facebook" },
  { icon: Youtube, href: CONTACT.youtube, key: "youtube", label: "YouTube" },
];

export const Footer = () => {
  const { reopen } = useConsent();
  return (
  <footer className="px-5 sm:px-8 lg:px-12 pt-10 pb-10" data-testid="footer">
    <div className="mx-auto max-w-7xl rounded-[2.5rem] glass px-6 sm:px-12 py-14 text-center">
      <img src={LOGO} alt="Cosplay Singers" className="mx-auto h-28 w-28 object-contain sm:h-44 sm:w-44 animate-float" />

      <p className="mx-auto mt-8 max-w-xl font-serif italic text-2xl sm:text-3xl leading-tight text-lavender-deep text-balance">
        “{FOOTER_LINE}”
      </p>

      <div className="mt-9 flex items-center justify-center gap-3">
        {socials.map(({ icon: Icon, href, key, label }) => (
          <a key={key} href={href} target="_blank" rel="noreferrer" data-testid={`footer-${key}`}
            aria-label={`Cosplay Singers su ${label}`}
            className="flex h-12 w-12 items-center justify-center rounded-full bg-white/70 text-navy-soft hover:bg-lavender hover:text-white transition-colors duration-300">
            <Icon size={20} />
          </a>
        ))}
      </div>

      <a href={`mailto:${CONTACT.email}`} data-testid="footer-email"
        className="mt-8 inline-block text-lg text-navy hover:text-lavender-deep transition-colors">
        {CONTACT.email}
      </a>

      <div className="mt-10 overflow-hidden">
        <h2 className="font-serif tracking-tightest text-[15vw] leading-[0.82] select-none"
          style={{ background: "linear-gradient(120deg, #EC4899, #3CB4F0, #3FBE82)", WebkitBackgroundClip: "text", backgroundClip: "text", color: "transparent" }}>
          Cosplay Singers
        </h2>
      </div>

      <div className="mt-6 flex flex-col gap-3 text-xs text-navy-faint sm:flex-row sm:items-center sm:justify-between">
        <span>© {new Date().getFullYear()} Cosplay Singers — {CONTACT.management}. Tutti i diritti riservati.</span>
        <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
          <a href="/privacy" data-testid="footer-privacy-link" className="hover:text-lavender-deep transition-colors">Privacy</a>
          <a href="/cookie" data-testid="footer-cookie-link" className="hover:text-lavender-deep transition-colors">Cookie</a>
          <button onClick={reopen} data-testid="footer-cookie-preferences" className="hover:text-lavender-deep transition-colors">Preferenze cookie</button>
          <a href="/admin" data-testid="footer-admin-link" className="hover:text-lavender-deep transition-colors">Area riservata</a>
        </div>
      </div>
    </div>
  </footer>
  );
};
